export const getTwoPointSixTimes = (number) => `${number * 1.6}px`;
export const getHeightPercentage = (adHeight) =>
  `${(getHeightMargin() * adHeight) / 100 - 10}px`;

export const getHeightMargin = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const height = searchParams.get("height");
  return height ?? 100;
};
